import type {FiltersHashmap} from '@Components/checkbox-filters/checkbox-filters.types';
import type {AccountStateFilter} from '@Components/social-media/social-media.types';
import {ACCOUNT_STATUS_CHECKBOX_GROUP_STATES, AccountStatusCheckboxGroup} from './account-status-checkboxes.types';

export const isCheckboxGroupChecked = (accountStateFilter: AccountStateFilter, group: AccountStatusCheckboxGroup): boolean => {
  return ACCOUNT_STATUS_CHECKBOX_GROUP_STATES[group].every((accountState) => accountStateFilter[accountState]);
};

/** Expands the two user-facing group toggles back into the full per-AccountState filter, leaving keys outside both groups (NEEDS_VALIDATION/REFRESHING) untouched. */
export const applyAccountStatusCheckboxGroupChanges = (accountStateFilter: AccountStateFilter, groupCheckedState: FiltersHashmap): AccountStateFilter => {
  const updatedFilter: AccountStateFilter = {...accountStateFilter};

  Object.values(AccountStatusCheckboxGroup).forEach((group) => {
    const isGroupChecked = groupCheckedState[group];
    ACCOUNT_STATUS_CHECKBOX_GROUP_STATES[group].forEach((accountState) => {
      updatedFilter[accountState] = isGroupChecked;
    });
  });

  return updatedFilter;
};
